import React from 'react';
import { List } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { SmartDiaryEntry } from '../type';
import { SimpleListItem } from './SimpleListItem';

type SmartListItemProps = { smartEntries: SmartDiaryEntry[] };

const useStyles = makeStyles(() => ({
  list: {
    paddingTop: 0,
    paddingBottom: 0
  }
}));
export const SimpleList: React.FC<SmartListItemProps> = ({
  smartEntries
}: SmartListItemProps) => {
  const classes = useStyles();
  return (
    <List data-testid="simple-diary-list" className={classes.list}>
      {smartEntries.map((smartEntry) => (
        <SimpleListItem key={smartEntry.id} smartEntry={smartEntry} />
      ))}
    </List>
  );
};
